export const STATE_PROP_NAME = 'esgEmailServerLocalDev'
